// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-text {
    max-width: 680px;
    padding: 1.5rem, 1.25rem;
    font-size: 1.1rem;
    line-height: 1.75;
    color: #2b2b2b;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.about-text p {
    margin-bottom: 1.4rem;
}

.about-text p:last-child {
    margin-bottom: 0;
}

.about-text strong {
    font-weight: 600;
}

.about-text .signature {
    margin-top: 2rem;
    font-style: italic;
    font-weight: 500;
    color: #555;
}`, "",{"version":3,"sources":["webpack://./src/components/About/about.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,mJAAmJ;AACvJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".about-text {\n    max-width: 680px;\n    padding: 1.5rem, 1.25rem;\n    font-size: 1.1rem;\n    line-height: 1.75;\n    color: #2b2b2b;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.about-text p {\n    margin-bottom: 1.4rem;\n}\n\n.about-text p:last-child {\n    margin-bottom: 0;\n}\n\n.about-text strong {\n    font-weight: 600;\n}\n\n.about-text .signature {\n    margin-top: 2rem;\n    font-style: italic;\n    font-weight: 500;\n    color: #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
